import type { OrderStatus } from '@/types/enums'

/**
 * Совпадает с логикой `StatusBadge`: приглушённый вариант для терминальных статусов.
 * Цвета текста бейджа — как в `src/theme.css` (`--stryzh-color-status-badge-*-text`).
 */
export function isStatusBadgeMutedVariant(status: OrderStatus): boolean {
  return (
    status === 'COMPLETED' ||
    status === 'CANCELLED' ||
    status === 'REFUSED_BY_INSPECTOR' ||
    status === 'REFUSED_BY_SELLER' ||
    status === 'REFUSED_BUYOUT'
  )
}

/** `--stryzh-color-status-badge-accent-text` */
export const STATUS_BADGE_ACCENT_TEXT_HEX = '#f7931a'

/** `--stryzh-color-status-badge-muted-text` */
export const STATUS_BADGE_MUTED_TEXT_HEX = '#94a3b8'
